export default __webpack_public_path__ + "static/media/edit-user.8b7d8b10.svg";